import { useState } from 'react';

export default function useAuthString() {
    const getAuthState = () => {
        const tokenString = sessionStorage.getItem('flask');

        if (!tokenString) {
            return { authString: null, authRole: null };
        }

        try {
            const parsedToken = JSON.parse(tokenString);
            if (parsedToken && typeof parsedToken === 'object') {
                return {
                    authString: parsedToken.authString || null,
                    authRole: parsedToken.authRole || 'publisher'
                };
            }
        } catch (e) {
            // fall back to legacy plain-string storage
        }

        return { authString: tokenString, authRole: 'publisher' };
    };

    const [authState, setAuthState] = useState(getAuthState());

    const saveAuthString = userToken => {
        const normalizedToken = typeof userToken === 'string'
            ? { authString: userToken, authRole: 'publisher' }
            : {
                authString: userToken.authString || null,
                authRole: userToken.authRole || 'publisher'
            };

        sessionStorage.setItem('flask', JSON.stringify(normalizedToken));
        setAuthState(normalizedToken);
    };

    const clearAuthString = () => {
        sessionStorage.removeItem('flask');
        setAuthState({ authString: null, authRole: null });
        console.log("User has been logged out.");
        console.log(sessionStorage.getItem('flask'));
    }

    return {
        clearAuthString,
        setAuthString: saveAuthString,
        authString: authState.authString,
        authRole: authState.authRole
    }
}